import { render, staticRenderFns } from "./BodyData.vue?vue&type=template&id=edb02944&scoped=true&"
import script from "./BodyData.vue?vue&type=script&lang=js&"
export * from "./BodyData.vue?vue&type=script&lang=js&"
import style0 from "./BodyData.vue?vue&type=style&index=0&id=edb02944&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb02944",
  null
  
)

export default component.exports